import { bool, number, shape, string } from 'prop-types'
import { iso8601PropType } from '../common/iso-8601-prop-type.js'
import { idPropType } from '../common/id-prop-type.js'

/**
 * @typedef {Object} OrderDocument
 * @property {ISO8601} creationTime - Creation date time
 * @property {string} documentId - ID of the document
 * @property {ISO8601} expirationTime - Expiration date time
 * @property {string} fileMimeType - Mime type of the document file
 * @property {string} fileName - Name of the document file
 * @property {number} fileSize - Size of the document file in bytes
 * @property {string} orderId - ID of the linked order
 * @property {bool} hasThumbnail - Flag if the document has a thumbnail image
 * @property {bool} uploadedByDriver - Flag if the document was uploaded by a driver
 * @property {string} [uploaderUserId] - ID of the uploading user
 */
export const orderDocumentPropType = shape({
    creationTime: iso8601PropType.isRequired,
    documentId: idPropType.isRequired,
    expirationTime: iso8601PropType.isRequired,
    fileMimeType: string.isRequired,
    fileName: string.isRequired,
    fileSize: number.isRequired,
    orderId: idPropType.isRequired,
    hasThumbnail: bool.isRequired,
    uploadedByDriver: bool.isRequired,
    uploaderUserId: idPropType
})
